import { getTimeZones } from "@vvo/tzdb";

export const TIME_ZONES = getTimeZones();
